import { bindActionCreators, Dispatch } from 'redux';
import goToNextNavigatorStep from '~/routes/calculations/goToNextNavigatorStep';
import * as modalActions from '~/containers/Modal/actions';
import { Action } from '~/redux/types';
import { GoToNextNavigatorStep } from '~/routes/calculations/types';

export interface Actions {
  actions: {
    openModal: (payload: string) => Action;
    closeModal: (payload: string) => Action;
    goToNextNavigatorStep: (args: GoToNextNavigatorStep) => void;
  };
}

export default (dispatch: Dispatch): Actions => ({
  actions: {
    ...bindActionCreators(
      {
        ...modalActions,
      },
      dispatch
    ),
    goToNextNavigatorStep,
  },
});
